@if (loading | async) {
    <div class="spinner-container d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div class="container mb-5">
        <div class="w-fit">
            <app-back-button routerLink="/organizations" component="Organizations"></app-back-button>
        </div>
        <div class="d-flex align-items-center mt-3">
            <div class="col-lg-4 col-12">
                <h1>Organization Entry</h1>
            </div>
        </div>
        <div class="row mt-4 mb-5">
            <form [formGroup]="basicInformationForm">
                <div class="container d-flex flex-column">
                    <h5 class="basic-info-title text-muted">BASIC INFORMATION</h5>
                </div>
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>Organization Name <span class="required-input">*</span></mat-label>
                            <input type="text" matInput placeholder="Organization Name" formControlName="legalName">
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline">
                            <mat-label>Guest-Friendly Name</mat-label>
                            <input type="text" matInput placeholder="Guest-Friendly Name" formControlName="displayName">
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>Website <span class="required-input">*</span></mat-label>
                            <input type="text" matInput placeholder="Website" formControlName="websiteUrl">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline">
                            <mat-label>Logo URL</mat-label>
                            <input type="text" matInput placeholder="Logo URL" formControlName="logoUrl">
                        </mat-form-field>
                    </div>
                </div>
                <hr>
                <div class="container d-flex flex-column">
                    <h5 class="contact-form-title text-muted">ADDRESS</h5>
                </div>
                <form formGroupName="addressForm">
                    <div class="row">
                        <div class="col d-flex flex-column">
                            <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Address Line 1<span class="required-input">*</span></mat-label>
                                <input type="text" matInput placeholder="Address 1" formControlName="addressLine1">
                            </mat-form-field>
                        </div>
                        <div class="col d-flex flex-column">
                            <mat-form-field appearance="outline">
                                <mat-label>Address Line 2</mat-label>
                                <input type="text" matInput placeholder="Address 2" formControlName="addressLine2">
                            </mat-form-field>
                        </div>
                        <div class="col d-flex flex-column">
                            <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>City<span class="required-input">*</span></mat-label>
                                <input type="text" matInput placeholder="City" formControlName="city">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col d-flex flex-column">
                            @if (usCountrySelectedBoolean) {
                                <mat-form-field appearance="outline" hideRequiredMarker>
                                    <mat-label>State<span class="required-input">*</span></mat-label>
                                    <mat-select formControlName="state" required>
                                        <mat-option *ngFor="let state of states" [value]="state.value">
                                            {{ state.label }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            } @else {
                                <mat-form-field appearance="outline">
                                    <mat-label>State/Province</mat-label>
                                    <input type="text" matInput placeholder="State/Province" formControlName="state">
                                </mat-form-field>
                            }
                        </div>
                        <div class="col d-flex flex-column">
                            <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Zip/Postal Code<span class="required-input">*</span></mat-label>
                                <input type="text" matInput placeholder="Zip/Postal Code" formControlName="postalCode">
                            </mat-form-field>
                        </div>
                        <div class="col d-flex flex-column">
                            <mat-form-field appearance="outline" hideRequiredMarker>
                                <mat-label>Country<span class="required-input">*</span></mat-label>
                                <mat-select formControlName="countryId" (selectionChange)="onCountrySelectionChange($event)">
                                    <mat-option *ngFor="let country of countries" [value]="country.id">
                                        {{ country.display_text }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </form>
                <hr>
                <div class="container d-flex flex-column">
                    <h5 class="contact-form-title text-muted">PRIMARY CONTACT</h5>
                </div>
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>First Name <span class="required-input">*</span></mat-label>
                            <input type="text" matInput placeholder="First Name" formControlName="contactFirstName">
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>Last Name <span class="required-input">*</span></mat-label>
                            <input type="text" matInput placeholder="Last Name" formControlName="contactLastName">
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>Phone Number <span class="required-input">*</span></mat-label>
                            <input type="text" matInput placeholder="Phone Number" formControlName="contactPhoneNumber" (input)="onPhoneNumberChanged($event)">
                            <mat-hint>Ex: (XXX) XXX-XXXX</mat-hint>
                            <mat-error *ngIf="basicInformationForm.controls['contactPhoneNumber'].invalid">
                                Required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>Email <span class="required-input">*</span></mat-label>
                            <input type="text" matInput placeholder="Email" formControlName="contactEmail">
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column"></div>
                    <div class="col d-flex flex-column"></div>
                </div>
                <hr>
                <div class="container d-flex flex-column">
                    <h5 class="contact-form-title text-muted">SETTINGS</h5>
                </div>
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>Safely Service<span class="required-input">*</span></mat-label>
                            <mat-select formControlName="safelyServiceId">
                                <mat-option *ngFor="let service of safelyServices" [value]="service.id">
                                    {{ service.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="basicInformationForm.get('safelyServiceId')?.invalid">Required</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>Notification Email <span class="required-input">*</span></mat-label>
                            <input type="text" matInput placeholder="Notification Email" formControlName="notificationEmail">
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column"></div>
                    <div class="col d-flex flex-column"></div>
                </div>
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-checkbox class="settings-checkbox" formControlName="sendCheckToSafely">
                            Claim Payments via ACH
                        </mat-checkbox>
                    </div>
                </div>
                <!-- TODO: Update/remove after tech planning discussion -->
                <!-- <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-checkbox class="settings-checkbox" formControlName="notifyGuestOnVerificationComplete">
                            Notify Guest on Verification Complete
                        </mat-checkbox>
                    </div>
                </div> -->
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-checkbox class="settings-checkbox" formControlName="notifyGuestForAdditionalInfo" (change)="onNotifyGuestForAdditionalInfoChange($event)">
                            Automated Guest Screening Emails
                        </mat-checkbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-checkbox class="settings-checkbox" formControlName="receiveEmailOnGuestVerificationComplete">
                            Receive Email When Guest Screening Completed
                        </mat-checkbox>
                    </div>
                </div>
                <!-- TODO: Update/remove after tech planning discussion -->
                <!-- <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-checkbox class="settings-checkbox" formControlName="receiveVirtualCheckInAlert">
                            Receive Virtual Check-In Alert
                        </mat-checkbox>
                    </div>
                </div> -->
            </form>
        </div>
        <div class="mt-2 mb-2 d-flex justify-content-end">
            <button mat-raised-button class="finish-button" routerLink="/organizations">
                <mat-icon>cancel</mat-icon>
                Cancel
            </button>
            <button mat-raised-button class="action-button submit-organization-button" [disabled]="!canCreateOrganization()" (click)="submitOrganization()">
                <mat-icon>check</mat-icon>
                Submit Organization
            </button>
        </div>
        <hr>
        <mat-action-row class="mt-4 d-flex justify-content-end">
            <div class="d-flex justify-content-end align-items-center text-muted" style="margin-right: 3;">
                <span class="required-input">*</span>&nbsp;- Required fields before submitting organization.
            </div>
        </mat-action-row>
    </div>
}